(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SmarttagPlugin", [], factory);
	else if(typeof exports === 'object')
		exports["SmarttagPlugin"] = factory();
	else
		root["SmarttagPlugin"] = factory();
})(window, function() {
return 